import { render, staticRenderFns } from "./AdmitFields.vue?vue&type=template&id=2b01c684&"
import script from "./AdmitFields.vue?vue&type=script&lang=ts&"
export * from "./AdmitFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports